if (!customElements.get('eu-warranty-notice')) {
  const COOKIE_NAME = 'eu_warranty_notice_language';

  class euWarrantyNotice extends HTMLElement {
    constructor() {
      super();
      this.onSelectChange = this.onSelectChange.bind(this);
    }

    connectedCallback() {
      this.select = this.querySelector('[data-eu-warranty-language]');
      if (!this.select) return;

      this.image = this.querySelector('[data-eu-warranty-image]');
      this.linkWrapper = this.querySelector('[data-eu-warranty-link-wrapper]');
      this.link = this.querySelector('[data-eu-warranty-link]');
      this.linkText = this.querySelector('[data-eu-warranty-link-text]');

      this.select.addEventListener('change', this.onSelectChange);
      this.restoreLanguage();
    }

    disconnectedCallback() {
      this.select?.removeEventListener('change', this.onSelectChange);
    }

    onSelectChange() {
      this.showLanguage();
      this.saveLanguage(this.select.value);
    }

    restoreLanguage() {
      const saved = this.readCookie();
      if (!saved || saved === this.select.value) return;
      if (!Array.from(this.select.options).some((option) => option.value === saved)) return;

      this.select.value = saved;
      this.showLanguage();
    }

    showLanguage() {
      const option = this.select.selectedOptions[0];
      if (!option) return;

      this.dataset.language = this.select.value;

      // update the image, url and link text
      const { noticeSrc, europeUrl = '', linkLabel } = option.dataset;
      if (this.image) this.image.src = noticeSrc;
      this.link && europeUrl ? (this.link.href = europeUrl) : this.link.removeAttribute('href');
      if (this.linkText) {
        this.linkText.textContent = linkLabel || this.linkText.dataset.euWarrantyLinkText;
      }
      this.linkWrapper?.classList.toggle('hidden', !europeUrl);
    }

    saveLanguage(language) {
      const value = encodeURIComponent(language);
      // current age is 1 year
      document.cookie = `${COOKIE_NAME}=${value}; max-age=${31536000}; path=/; SameSite=Lax; Secure`;
    }

    readCookie() {
      const cookie = document.cookie
        .split('; ')
        .find((entry) => entry.startsWith(`${COOKIE_NAME}=`));

      return cookie ? decodeURIComponent(cookie.split('=').slice(1).join('=')) : '';
    }
  }

  customElements.define('eu-warranty-notice', euWarrantyNotice);
}
